const VerifyBankAccount = ({
  loading,
  verified,
  error,
  disabled,
  onVerify,
}) => {
  return (
    <div
      className={`mt-2 flex items-center justify-between rounded-lg border px-3 py-2 ${
        error
          ? "border-red-200 bg-red-50"
          : verified
          ? "border-green-200 bg-green-50"
          : "border-primary-color/10 bg-primary-color/10"
      }`}
    >
      <div className="flex items-center gap-2">

        <span
          className={`text-xs ${
            error
              ? "text-red-600"
              : verified
              ? "text-green-700"
              : "text-primary-color"
          }`}
        >
          {error ? error : verified ? "Account Verified" : "Verify account holder name before transfer"}
        </span>
      </div>

      {!verified && (
        <button
          type="button"
          disabled={disabled || loading}
          onClick={onVerify}
          className="rounded-md bg-primary-color px-3 py-1 text-sm text-white disabled:cursor-not-allowed disabled:bg-gray-300"
        >
          {loading ? "Verifying..." : "Verify"}
        </button>
      )}
    </div>
  );
};

export default VerifyBankAccount;